module.exports = __webpack_public_path__ + "img/history.900a9d39.svg";